import { FunctionComponent } from 'react'
import { Container } from '@mui/material'
import TabContainer from '../../../LoginOrSignup/components/tabs/TabContainer'
import { AccountOptions } from '../../../LoginOrSignup/enum/AccountOptions'
import MiniWidgetLogin from '../widgetLogin/MiniWidgetLogin'
import MiniWidgetSignup from '../widgetSignup/MiniWidgetSignup'

const MiniWidgetTabs: FunctionComponent = () => {
  return (
    <Container>
      <TabContainer
        tabs={[
          {
            component: <MiniWidgetLogin />,
            title:
              'trans__checkout__next_step__saved_my_build__log_in_modal_label',
            value: AccountOptions.LOGIN,
          },
          {
            component: <MiniWidgetSignup />,
            title:
              'trans__checkout__next_step__saved_my_build__sign_up_modal_label',
            value: AccountOptions.REGISTER,
          },
        ]}
        data-test="mini:myaccount:auth"
      />
    </Container>
  )
}

export default MiniWidgetTabs
